import React from "react";
import { useContent } from "../context/ContentContext";
import SafeImage from "../components/SafeImage";

export default function Gallery() {
  const { content } = useContent();
  const g = content.gallery || {};
  const images = g.images || [];
  return (
    <div className="container py-4">
      <h1 className="mb-4 text-success">{g.title || "Gallery"}</h1>
      <div className="row g-4">
        {images.map((img, i) => (
          <div key={i} className="col-md-4">
            <div className="card h-100 shadow-sm">
              <SafeImage src={img.src} className="card-img-top" alt={img.caption} style={{ height: 180, objectFit: "cover" }} />
              <div className="card-body">
                <p className="card-text text-center">{img.caption}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
